<template>
    <div>
        <PageHeader :title="`${title} <small class='text-muted'>(${this.totalRows})</small>`">
            <div class="flex-fill d-flex justify-content-end">
                <b-button class="d-inline-flex align-items-center" variant="primary" size="sm" @click="$emit('new')"> <i class="bx bx-plus font-size-17"> </i></b-button>
                <b-button variant="dark" class="btn-label text-dark ml-3">
                    <i class="bx bx-printer label-icon"></i>
                    <span>Imprimer</span>
                </b-button>
            </div>
        </PageHeader>

        <div class="card">
            <div class="card-body">
                <vue-form-generator ref="form" class="mb-3" tag="div" :schema="filtersSchema" :model="filters" :options="{ validateAfterChanged: true }" />

                <b-table :items="rows" :fields="fields" :current-page="currentPage" striped primary-key="id" head-variant="dark" :tbody-tr-class="item => item._showDetails && 'bg-soft-primary'">
                    <template v-for="slotName in Object.keys($scopedSlots)" v-slot:[slotName]="slotScope">
                        <slot :name="slotName" v-bind="slotScope"></slot>
                    </template>
                </b-table>

                <div class="d-flex justify-content-end" v-if="totalRows > perPage">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                </div>
            </div>
        </div>

        <Loader full light :loading="loading" />
    </div>
</template>

<script>
    import PageHeader from "@/components/page-header";
    import Loader from "./ui/loader";

    export default {
        props: {
            title: String,
            api: String,
            fields: {
                type: Array,
                default: () => []
            },
            filtersSchema: {
                type: Object,
                default: () => ({})
            },
            filters: {
                type: Object,
                default: () => ({})
            }
        },
        components: {
            PageHeader,
            Loader
        },
        data: () => ({
            rows: [],
            totalRows: null,
            perPage: null,
            currentPage: 1,
            loading: true
        }),
        watch: {
            filters: {
                deep: true,
                handler() {
                    this.currentPage = 1;
                    this.loadData();
                }
            },
            currentPage() {
                window.scrollTo({ top: 0, behavior: "smooth" });
                this.loadData(true);
            }
        },
        methods: {
            async loadData(showLoader) {
                try {
                    showLoader && (this.loading = true);

                    let filters = Object.entries(this.filters).map(([key, value]) => {
                        if (Array.isArray(value)) return { [key]: value.every(item => item) ? value.map(item => item.id || item) : [] };
                        else return { [key]: value?.id || value };
                    });
                    filters = Object.assign({}, ...filters);

                    const resp = await this.$axios.get(this.api, { params: { ...filters, page: this.currentPage } });
                    this.rows = resp.data;
                    this.totalRows = resp.count;
                    this.perPage = resp.perPage;
                    if (resp.extraData) this.$emit("extra-data", resp.extraData);
                } finally {
                    this.loading = false;
                }
            }
        },
        mounted() {
            this.loadData(true);
        }
    };
</script>
